<template>
  <div id="app">
    <RouterView name="default" />
  </div>
  
</template>

<script>


export default {
  name: 'App',
  created() {
    this.$store.dispatch('encuesta/getData')
    this.$store.dispatch('encuesta/getQuestion')
  }
}
</script>

<style lang="scss">
  @import "assets/main.scss";
</style>
